module.exports = __webpack_public_path__ + "static/media/logo-small.3650ebc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-small.png
// module id = 711
// module chunks = 37